import { render } from "./IconSorting.vue?vue&type=template&id=1f2c7ba5"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconSorting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f2c7ba5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f2c7ba5', __exports__)) {
    api.reload('1f2c7ba5', __exports__)
  }
  
  module.hot.accept("./IconSorting.vue?vue&type=template&id=1f2c7ba5", () => {
    api.rerender('1f2c7ba5', render)
  })

}


export default __exports__